import React, { FC, useEffect } from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'

import Button from '../../../../../components/Atoms/Button/Button'

import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'

const IndividualDeclarationsForm: FC<FormProps> = props => {
  const submitForm = ({data, options, configData, setConfigData}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options, configData, setConfigData })
  }

  const {
    formData,
    setFormData,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(
    props.fetchedData,
    config,
    submitForm
  )
  const isDisableByCheckbox = () => ['certifyAccountHolder','allStatmentsMadeCorrect','takeSucdenAdvise','dataProtectionPolicyConfirmation','acknowledgeInformationOnForm','fundsRiskConfirmation','agreeToBoundForProvisions']
  // @ts-ignore
    .some(item => formData[`${item}`].value === false || formData[`${item}`].value === '')

  const isDisableByCheckboxMarketing = () => ['optForInfoByMail','optForInfoByEMail','optForInfoByPhone']
  // @ts-ignore
    .some(item => formData[`${item}`].value === true)

  useEffect(() => {
    const mail = (document.querySelector('input[name="optForInfoByMail"]') as HTMLInputElement)
    const email = (document.querySelector('input[name="optForInfoByEMail"]') as HTMLInputElement)
    const phone = (document.querySelector('input[name="optForInfoByPhone"]') as HTMLInputElement)
    const noOpt = (document.querySelector('input[name="notOptForInformation"]') as HTMLInputElement)
    if(formData?.optForInfoByMail?.value || formData?.optForInfoByPhone?.value || formData?.optForInfoByEMail?.value){
      noOpt.disabled = true
      noOpt.checked = false
    } else {
      noOpt.disabled = false
    }
    if(formData?.notOptForInformation?.value){
      mail.disabled = true
      email.disabled = true
      phone.disabled = true
      mail.checked = false
      email.checked = false
      phone.checked = false
      // @ts-ignore:next-line
      setFormData(prev => {
        return {
          ...prev,
          optForInfoByMail: {...prev.optForInfoByMail, value: false},
          optForInfoByPhone: {...prev.optForInfoByPhone, value: false},
          optForInfoByEMail: {...prev.optForInfoByEMail, value: false}
        }
      })
    } else {
      mail.disabled = false
      email.disabled = false
      phone.disabled = false
    }
  },[formData?.optForInfoByMail?.value, formData?.optForInfoByPhone?.value, formData?.optForInfoByEMail?.value, formData?.notOptForInformation?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.IndividualAccount.DeclarationsForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.IndividualAccount.DeclarationsForm.description' components={{requiredMark: <RequiredMark />}}/>
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={
              isDisableByCheckbox() ||
              //@ts-ignore:next-line
              ((formData.notOptForInformation.value === false || formData.notOptForInformation.value === '') &&
              !isDisableByCheckboxMarketing())
            }
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualDeclarationsForm
